var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 821.751,
    height: 886.619,
    viewBox: "726.5 -104.735 821.751 886.619",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1463.23 55.352 1222.397-82.2c-52.613-30.048-117.43-30.048-170.042 0L811.52 55.35C758.911 85.4 726.5 140.932 726.5 201.026v275.1c0 11.017 1.1 21.875 3.203 32.455 9.367 47.138 38.852 88.68 81.818 113.22l240.834 137.549c52.612 30.047 117.43 30.047 170.042 0L1463.23 621.8c41.053-23.45 69.806-62.414 80.457-106.958a166.387 166.387 0 0 0 4.564-38.719V201.025c0-60.095-32.411-115.626-85.02-145.673",
    fill: "#feae34",
    fillRule: "evenodd",
    "data-name": "Path 35582"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.5750bf244737b70366505258b02fcd2b.svg";
export { ForwardRef as ReactComponent };